<template>
  <div>
    <div class="columns is-multiline is-mobile">
      <div class="column is-full">
        <window :showHeader="false">
          <p>Find documentation
            <a href="https://github.com/ankane/vue-chartkick" target="_blank">here</a>.</p>
          <p>Examples
            <a href="https://www.chartkick.com/vue" target="_blank">here</a>.</p>
          <p>Some other examples
            <a href="https://codepen.io/SitePoint/pen/oeXZjO" target="_blank">here</a>.</p>
        </window>
      </div>
      <div class="column is-full">
        <window title="Line chart">
          <line-chart :data="{'2017-01-01': 11, '2017-01-02': 6}"></line-chart>
        </window>
      </div>
      <div class="column is-full">
        <window title="Line chart">
          <line-chart :data="dataLineChart2"></line-chart>
        </window>
      </div>
      <div class="column is-full">
        <window title="Column chart">
          <column-chart :data="[
            ['Sun', 32], ['Mon', 46], ['Tue', 28], ['Wed', 18], ['Thu', 16], ['Sat', 70]
          ]"></column-chart>
        </window>
      </div>
      <div class="column is-full">
        <window title="Bar chart">
          <bar-chart :data="[
            ['Australia', 5], ['China', 27], ['Romania', 127], ['Serbia', 13]
          ]"></bar-chart>
        </window>
      </div>
      <div class="column is-full">
        <window title="Area chart">
          <area-chart :data="{
            '2017-01-01 00:00:00 -0800': 2,
            '2017-01-01 00:01:00 -0800': 5,
            '2017-01-01 00:02:00 -0800': 1,
            '2017-01-01 00:03:00 -0800': 7}"
          ></area-chart>
        </window>
      </div>
      <div class="column is-full">
        <window title="Scatter chart">
          <scatter-chart :data="dataScatterChart" />
        </window>
      </div>
      <div class="column is-full">
        <window title="Pie chart">
          <pie-chart :data="[['Blueberry', 44], ['Strawberry', 23], ['Raspberry', 10]]"></pie-chart>
        </window>
      </div>
      <div class="column is-full">
        <window title="Multiple series line chart">
          <line-chart :data="dataMultipleLineChart" />
        </window>
      </div>
      <div class="column is-full">
        <window title="Multiple series area chart">
          <area-chart :data="dataMultipleAreaChart" />
        </window>
      </div>
      <div class="column is-full">
        <window title="Multiple bar chart">
          <bar-chart :data="dataMultipleBarChart"></bar-chart>
        </window>
      </div>
      <div class="column is-full">
        <window title="Stacked bar chart">
          <bar-chart :data="dataStackedBarChart"></bar-chart>
        </window>
      </div>
    </div>
  </div>
</template>


<script>

import Vue from 'vue';
import VueChartkick from 'vue-chartkick';

Vue.use(VueChartkick);

export default {
  components: {
    VueChartkick,
  },
  data() {
    return {
      dataLineChart2: [
        ['Jan', 44], ['Feb', 27], ['Mar', 60], ['Apr', 55], ['May', 37], ['Jun', 40], ['Jul', 69], ['Aug', 33], ['Sept', 76], ['Oct', 90], ['Nov', 34], ['Dec', 22],
      ],
      dataScatterChart: [
        {
          name: 'Workout',
          data: [
            [174.0, 80.0],
            [126.0, 70.0],
            [182.0, 85.0],
            [91.0, 37.0],
          ],
        },
        {
          name: 'Music classes',
          data: [
            [274.0, 80.0],
            [282.0, 85.0],
            [226.0, 70.0],
            [21.0, 37.0],
          ],
        },
        {
          name: 'School',
          data: [
            [74.0, 80.0],
            [82.0, 85.0],
            [26.0, 70.0],
            [21.0, 87.0],
          ],
        },
      ],
      dataMultipleLineChart: [
        {
          name: 'Workout',
          data: {
            '2017-01-01 00:00:00 -0800': 3,
            '2017-01-02 00:00:00 -0800': 4,
            '2017-01-03 00:00:00 -0800': 5,
            '2017-01-04 00:00:00 -0800': 3,
          },
        },
        {
          name: 'Music classes',
          data: {
            '2017-01-01 00:00:00 -0800': 5,
            '2017-01-02 00:00:00 -0800': 3,
            '2017-01-03 00:00:00 -0800': 5,
            '2017-01-04 00:00:00 -0800': 10,
          },
        },
        {
          name: 'School',
          data: {
            '2017-01-01 00:00:00 -0800': 10,
            '2017-01-02 00:00:00 -0800': 2,
            '2017-01-03 00:00:00 -0800': 7,
            '2017-01-04 00:00:00 -0800': 9,
          },
        },
      ],
      dataMultipleAreaChart: [
        {
          name: 'Workout',
          data: {
            '2017-01-01 00:00:00 -0800': 3,
            '2017-01-02 00:00:00 -0800': 4,
            '2017-01-03 00:00:00 -0800': 5,
            '2017-01-04 00:00:00 -0800': 3,
          },
          color: '#ff0000',
        },
        {
          name: 'Music classes',
          data: {
            '2017-01-01 00:00:00 -0800': 5,
            '2017-01-02 00:00:00 -0800': 3,
            '2017-01-03 00:00:00 -0800': 5,
            '2017-01-04 00:00:00 -0800': 10,
          },
          color: '#ff0033',
        },
        {
          name: 'School',
          data: {
            '2017-01-01 00:00:00 -0800': 10,
            '2017-01-02 00:00:00 -0800': 2,
            '2017-01-03 00:00:00 -0800': 7,
            '2017-01-04 00:00:00 -0800': 9,
          },
          color: '#f6c68b',
        },
      ],
      dataMultipleBarChart: [
        {
          name: 'Workout',
          data: {
            '2017-01-01 00:00:00 -0800': 3,
            '2017-01-02 00:00:00 -0800': 4,
            '2017-01-03 00:00:00 -0800': 5,
            '2017-01-04 00:00:00 -0800': 3,
          },
        },
        {
          name: 'Music classes',
          data: {
            '2017-01-01 00:00:00 -0800': 5,
            '2017-01-02 00:00:00 -0800': 3,
            '2017-01-03 00:00:00 -0800': 5,
            '2017-01-04 00:00:00 -0800': 10,
          },
        },
        {
          name: 'School',
          data: {
            '2017-01-01 00:00:00 -0800': 10,
            '2017-01-02 00:00:00 -0800': 2,
            '2017-01-03 00:00:00 -0800': 7,
            '2017-01-04 00:00:00 -0800': 9,
          },
        },
      ],
      dataStackedBarChart: [
        {
          name: 'Workout',
          data: {
            '2017-01-01 00:00:00 -0800': 3,
            '2017-01-02 00:00:00 -0800': 4,
            '2017-01-03 00:00:00 -0800': 5,
            '2017-01-04 00:00:00 -0800': 3,
          },
          stack: 'stack1',
        },
        {
          name: 'Music classes',
          data: {
            '2017-01-01 00:00:00 -0800': 5,
            '2017-01-02 00:00:00 -0800': 3,
            '2017-01-03 00:00:00 -0800': 5,
            '2017-01-04 00:00:00 -0800': 10,
          },
          stack: 'stack1',
        },
        {
          name: 'School',
          data: {
            '2017-01-01 00:00:00 -0800': 10,
            '2017-01-02 00:00:00 -0800': 2,
            '2017-01-03 00:00:00 -0800': 7,
            '2017-01-04 00:00:00 -0800': 9,
          },
        },
      ],
    };
  },
};
</script>

